import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class BookMeetingMessageRecord
 * @augments BaseMessageRecord
 */
class BookMeetingMessageRecord extends BaseMessageRecord({
  type: "book_meeting_recipe",

  /**
   * @memberof BookMeetingMessageRecord#
   */
  messagesRecipe: Immutable.List([
    Immutable.Map({
      type: "capture",
      locked: false,
      captureLead: "Let's book you some time with one of our experts. First, what's your email address?",
      captureKey: "email",
      captureLocked: false,
      captureType: "email"
    }),
    Immutable.Map({
      type: "book_meeting",
      dialogMessage: "Please choose a time from the options below",
      serviceId: "",
      duration: "",
      title: "",
      description: "",
      unavailableResponseId: "",
      errorResponseId: "",
      locked: false
    }),
    Immutable.Map({
      body: "We'll be in touch by email shortly!",
      type: "text",
      locked: false
    })
  ])
}) {}

/**
 * Validation
 */

/**
 * @param {BookMeetingMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
BookMeetingMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (message.messagesRecipe.getIn([0, "captureLead"]).length <= 0) {
    invalidFields.add("captureLead");
  }

  if (message.messagesRecipe.getIn([1, "dialogMessage"]).length <= 0) {
    invalidFields.add("dialogMessage");
  }

  if (!message.messagesRecipe.getIn([1, "serviceId"])) {
    invalidFields.add("serviceId");
  }

  if (!message.messagesRecipe.getIn([1, "duration"])) {
    invalidFields.add("duration");
  }

  if (message.messagesRecipe.getIn([1, "title"]).length <= 0) {
    invalidFields.add("title");
  }

  if (message.messagesRecipe.getIn([1, "description"]).length <= 0) {
    invalidFields.add("description");
  }

  if (!message.messagesRecipe.getIn([1, "unavailableResponseId"])) {
    invalidFields.add("unavailableResponseId");
  }

  if (!message.messagesRecipe.getIn([1, "errorResponseId"])) {
    invalidFields.add("errorResponseId");
  }

  if (message.messagesRecipe.getIn([2, "body"]).length <= 0) {
    invalidFields.add("body");
  }

  return Immutable.List(invalidFields);
};

export default BookMeetingMessageRecord;
